import { createAction } from '@reduxjs/toolkit';

export const SESSIONS_UPDATED_ACTION_TYPE = 'saga/sessionsUpdated';
export const sessionsUpdatedAction = createAction(SESSIONS_UPDATED_ACTION_TYPE);
